const defaultLocale = 'en-US'

type Currency = 'USD' | 'EUR'

export const formatters = {
  currency: (val: number | undefined, currency: Currency) =>
    val === null || val == undefined
      ? undefined
      : new Intl.NumberFormat(defaultLocale, {
          style: 'currency',
          currency: currency
        }).format(+val.toFixed(2)),
  percentage: (val?: number) =>
    val === null || val == undefined
      ? null
      : new Intl.NumberFormat(defaultLocale, {
          style: 'percent',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(val),
  number: (val?: number) =>
    val === null || val == undefined
      ? null
      : new Intl.NumberFormat(defaultLocale, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(+val.toFixed(2))
}
